import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'menu-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 18 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 12C0.716667 12 0.479167 11.9042 0.2875 11.7125C0.0958333 11.5208 0 11.2833 0 11C0 10.7167 0.0958333 10.4792 0.2875 10.2875C0.479167 10.0958 0.716667 10 1 10H17C17.2833 10 17.5208 10.0958 17.7125 10.2875C17.9042 10.4792 18 10.7167 18 11C18 11.2833 17.9042 11.5208 17.7125 11.7125C17.5208 11.9042 17.2833 12 17 12H1ZM1 7C0.716667 7 0.479167 6.90417 0.2875 6.7125C0.0958333 6.52083 0 6.28333 0 6C0 5.71667 0.0958333 5.47917 0.2875 5.2875C0.479167 5.09583 0.716667 5 1 5H17C17.2833 5 17.5208 5.09583 17.7125 5.2875C17.9042 5.47917 18 5.71667 18 6C18 6.28333 17.9042 6.52083 17.7125 6.7125C17.5208 6.90417 17.2833 7 17 7H1ZM1 2C0.716667 2 0.479167 1.90417 0.2875 1.7125C0.0958333 1.52083 0 1.28333 0 1C0 0.716667 0.0958333 0.479167 0.2875 0.2875C0.479167 0.0958333 0.716667 0 1 0H17C17.2833 0 17.5208 0.0958333 17.7125 0.2875C17.9042 0.479167 18 0.716667 18 1C18 1.28333 17.9042 1.52083 17.7125 1.7125C17.5208 1.90417 17.2833 2 17 2H1Z"
      fill="currentColor" />
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuIcon {}

@Component({
  selector: 'home-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.4896 18H13.5937C12.7546 18 12.0833 17.3101 12.0833 16.475V10.6051C12.0833 10.4357 11.9394 10.2905 11.7716 10.2905H7.22839C7.06057 10.2905 6.91672 10.4357 6.91672 10.6051V16.475C6.91672 17.3222 6.23344 18 5.40631 18H1.51041C0.671293 18 0 17.3101 0 16.475V8.54765C0 7.74886 0.347634 6.99849 0.947003 6.47806L7.75584 0.644478C8.76278 -0.214826 10.2252 -0.214826 11.2322 0.644478L18.053 6.47806C18.6524 6.99849 19 7.74886 19 8.54765V16.475C19 17.3222 18.3167 18 17.4896 18ZM7.22839 9.08018H11.7716C12.6107 9.08018 13.282 9.77005 13.282 10.6051V16.475C13.282 16.6445 13.4259 16.7897 13.5937 16.7897H17.4896C17.6574 16.7897 17.8013 16.6445 17.8013 16.475V8.54765C17.8013 8.09985 17.6095 7.68835 17.2738 7.39788L10.453 1.56429C9.88959 1.09228 9.08644 1.09228 8.52303 1.56429L1.7142 7.39788C1.37855 7.68835 1.18675 8.09985 1.18675 8.54765V16.475C1.18675 16.6445 1.3306 16.7897 1.49842 16.7897H5.39432C5.56214 16.7897 5.70599 16.6445 5.70599 16.475V10.6051C5.70599 9.75794 6.38927 9.08018 7.2164 9.08018H7.22839Z"
      fill="currentColor" />
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeIcon {}

@Component({
  selector: 'ranking-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.79929 17.9975C4.40513 17.9975 4.01097 17.8821 3.6752 17.637C3.07667 17.2043 2.7847 16.4977 2.91608 15.7911L3.60221 11.8541C3.63141 11.7099 3.57302 11.5513 3.47083 11.4503L0.580327 8.66706C0.054781 8.16232 -0.135002 7.41243 0.0985739 6.73464C0.33215 6.04243 0.916091 5.55211 1.64602 5.45117L5.646 4.87432C5.79198 4.8599 5.92337 4.75895 5.99636 4.62916L7.77738 1.05274C8.09854 0.403789 8.75547 0 9.5 0C10.2445 0 10.8869 0.403789 11.2226 1.05274L13.0036 4.62916C13.0766 4.75895 13.1934 4.8599 13.354 4.87432L17.354 5.45117C18.0839 5.55211 18.6679 6.04243 18.9014 6.73464C19.135 7.42685 18.9452 8.16232 18.4197 8.66706L15.5292 11.4503C15.427 11.5513 15.3686 11.7099 15.3978 11.8541L16.0839 15.7911C16.2153 16.5121 15.9233 17.2187 15.3248 17.637C14.7263 18.0696 13.9525 18.1129 13.3102 17.7812L9.73357 15.9209C9.60219 15.8487 9.44161 15.8487 9.31022 15.9209L5.73359 17.7812C5.45622 17.9254 5.14965 17.9975 4.84308 17.9975H4.79929ZM9.4708 1.42769C9.38321 1.42769 9.17883 1.45653 9.06204 1.67284L7.28103 5.24927C7.00366 5.81169 6.46351 6.20106 5.83578 6.28758L1.83579 6.86443C1.58762 6.90769 1.50003 7.09516 1.47083 7.16727C1.44163 7.2538 1.39784 7.45569 1.58762 7.62874L4.47812 10.412C4.93067 10.8446 5.13505 11.4792 5.03286 12.0849L4.34673 16.0218C4.30294 16.267 4.46352 16.4112 4.52191 16.4689C4.59491 16.5121 4.77009 16.6275 5.00367 16.4977L8.5803 14.6374C9.13504 14.349 9.80657 14.349 10.3613 14.6374L13.9379 16.4977C14.1715 16.6131 14.3467 16.5121 14.4197 16.4689C14.4927 16.4256 14.6387 16.2814 14.5949 16.0218L13.9087 12.0849C13.8066 11.4647 14.0109 10.8446 14.4635 10.412L17.354 7.62874C17.5438 7.45569 17.5 7.23938 17.4708 7.16727C17.4416 7.08074 17.354 6.89327 17.1058 6.86443L13.1058 6.28758C12.4781 6.20106 11.9379 5.81169 11.6606 5.24927L9.87956 1.67284C9.76277 1.44211 9.55839 1.42769 9.4708 1.42769Z"
      fill="currentColor" />
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RankingIcon {}

@Component({
  selector: 'missions-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.04861 14.0214C8.88795 14.0214 8.72729 13.9596 8.61607 13.8361L4.67374 9.89449C4.50072 9.72151 4.45128 9.47438 4.52543 9.25197C6.29268 4.30953 11.2484 -0.595846 16.9703 0.0590277C17.7366 0.14552 18.3545 0.763329 18.441 1.52941C19.096 7.23793 14.1897 12.1927 9.24634 13.972C9.17219 13.9967 9.1104 14.0091 9.03625 14.0091L9.04861 14.0214ZM5.83543 9.31375L9.20927 12.687C13.0157 11.1672 17.8231 6.90431 17.2299 1.69003C17.2051 1.49234 17.0445 1.31935 16.8344 1.29464C11.6068 0.689189 7.34315 5.50807 5.83543 9.31375Z"
      fill="currentColor" />
    <path
      d="M2.74589 17.4317C2.31335 17.4317 1.89315 17.2587 1.57184 16.9374C1.13929 16.505 0.978637 15.8748 1.15165 15.2941C1.38646 14.528 1.78193 13.6631 2.30099 12.7611C2.56051 12.3039 3.00541 12.0073 3.53683 11.9456C4.05588 11.8714 4.56257 12.0444 4.93332 12.4151L6.09501 13.5766C6.46576 13.9473 6.63878 14.4538 6.56463 14.9728C6.49048 15.4918 6.19388 15.9366 5.74898 16.2084C4.83446 16.7397 3.99408 17.1228 3.25258 17.3575H3.22787C3.06721 17.407 2.90654 17.4317 2.75824 17.4317H2.74589ZM3.75928 13.1688C3.75928 13.1688 3.7222 13.1688 3.69748 13.1688C3.56154 13.1812 3.43795 13.2677 3.37616 13.3789C2.90654 14.1944 2.54815 14.9852 2.33806 15.64C2.27627 15.8624 2.38749 16.0107 2.44928 16.0601C2.49871 16.1096 2.64702 16.2331 2.85711 16.1713C3.52446 15.9613 4.30305 15.603 5.13106 15.1334C5.25464 15.0593 5.32879 14.9481 5.34115 14.8122C5.34115 14.738 5.34115 14.5774 5.21757 14.4539L4.05588 13.2924C3.95701 13.1935 3.83343 13.1688 3.75928 13.1688Z"
      fill="currentColor" />
    <path
      d="M5.10639 10.0798H2.00443C1.48538 10.0798 1.01576 9.82027 0.731521 9.37545C0.459636 8.94299 0.422561 8.41168 0.645012 7.9545C1.3618 6.4347 3.27735 3.92641 7.88703 4.18589C8.23307 4.19824 8.4926 4.49479 8.46788 4.84076C8.45552 5.18674 8.15892 5.44621 7.81289 5.4215C4.10537 5.2238 2.4617 6.97837 1.74491 8.49817C1.69547 8.59702 1.74491 8.68351 1.75727 8.73293C1.78199 8.77 1.85614 8.8565 1.97972 8.8565H5.08168C5.42772 8.8565 5.6996 9.12833 5.6996 9.4743C5.6996 9.82027 5.42772 10.0921 5.08168 10.0921L5.10639 10.0798Z"
      fill="currentColor" />
    <path
      d="M9.92603 18.0001C9.65414 18.0001 9.38226 17.926 9.13509 17.7653C8.70255 17.4935 8.43066 17.0116 8.43066 16.4927V13.3913C8.43066 13.0453 8.70255 12.7735 9.04858 12.7735C9.39462 12.7735 9.6665 13.0453 9.6665 13.3913V16.4927C9.6665 16.6286 9.75301 16.6904 9.79009 16.7151C9.82716 16.7398 9.91367 16.7769 10.0249 16.7274C11.5326 16.0108 13.2999 14.3674 13.1021 10.6606C13.0774 10.3146 13.3493 10.0304 13.683 10.0057C14.029 9.981 14.3133 10.2528 14.338 10.5864C14.5851 15.2076 12.0764 17.1105 10.5687 17.8271C10.3709 17.926 10.1485 17.9754 9.93839 17.9754L9.92603 18.0001Z"
      fill="currentColor" />
    <path
      d="M12.2989 8.37444C11.1002 8.37444 10.1362 7.39831 10.1362 6.21212C10.1362 5.02594 11.1125 4.0498 12.2989 4.0498C13.4854 4.0498 14.4617 5.02594 14.4617 6.21212C14.4617 7.39831 13.4854 8.37444 12.2989 8.37444ZM12.2989 5.28542C11.7799 5.28542 11.3597 5.70553 11.3597 6.22448C11.3597 6.74344 11.7799 7.16354 12.2989 7.16354C12.818 7.16354 13.2382 6.74344 13.2382 6.22448C13.2382 5.70553 12.818 5.28542 12.2989 5.28542Z"
      fill="currentColor" />
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MissionsIcon {}

@Component({
  selector: 'history-icon',
  imports: [],
  template: `<svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.85176 17.9999C9.49351 17.9999 9.21202 17.723 9.21202 17.3706C9.21202 17.0181 9.49351 16.7412 9.85176 16.7412C14.1892 16.7412 17.7205 13.2671 17.7205 8.99997C17.7205 4.73285 14.1892 1.25874 9.85176 1.25874C5.51433 1.25874 1.98297 4.73285 1.98297 8.99997C1.98297 9.35242 1.70148 9.62934 1.34323 9.62934C0.984976 9.62934 0.703491 9.35242 0.703491 8.99997C0.703491 4.04055 4.81062 0 9.85176 0C14.8929 0 19 4.04055 19 8.99997C19 13.9594 14.8929 17.9999 9.85176 17.9999Z"
      fill="currentColor" />
    <path
      d="M9.8519 9.64197C9.49364 9.64197 9.21216 9.36505 9.21216 9.01261V3.7385C9.21216 3.38605 9.49364 3.10913 9.8519 3.10913C10.2102 3.10913 10.4916 3.38605 10.4916 3.7385V9.01261C10.4916 9.36505 10.2102 9.64197 9.8519 9.64197Z"
      fill="currentColor" />
    <path
      d="M9.85198 17.9999H0.639739C0.281485 17.9999 0 17.723 0 17.3706C0 17.0181 0.281485 16.7412 0.639739 16.7412H9.85198C10.2102 16.7412 10.4917 17.0181 10.4917 17.3706C10.4917 17.723 10.2102 17.9999 9.85198 17.9999Z"
      fill="currentColor" />
    <path
      d="M6.30783 15.1301H0.639739C0.281485 15.1301 0 14.8532 0 14.5007C0 14.1483 0.281485 13.8713 0.639739 13.8713H6.30783C6.66608 13.8713 6.94757 14.1483 6.94757 14.5007C6.94757 14.8532 6.66608 15.1301 6.30783 15.1301Z"
      fill="currentColor" />
    <path
      d="M4.27346 12.2602H0.639739C0.281485 12.2602 0 11.9833 0 11.6308C0 11.2784 0.281485 11.0015 0.639739 11.0015H4.27346C4.63172 11.0015 4.9132 11.2784 4.9132 11.6308C4.9132 11.9833 4.63172 12.2602 4.27346 12.2602Z"
      fill="currentColor" />
    <path
      d="M11.5792 11.341C11.4129 11.341 11.2465 11.278 11.1314 11.1522L9.40408 9.45288C9.14818 9.21372 9.14818 8.81092 9.40408 8.55917C9.65998 8.30742 10.0566 8.30742 10.3125 8.55917L12.0398 10.2585C12.2957 10.4976 12.2957 10.9004 12.0398 11.1522C11.9119 11.278 11.7455 11.341 11.592 11.341H11.5792Z"
      fill="currentColor" />
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryIcon {}

@Component({
  selector: 'redeem-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.88957 11.0184C2.81498 11.0184 0.5 9.76691 0.5 8.12274C0.5 6.47858 2.81498 5.22705 5.88957 5.22705C8.96415 5.22705 11.2791 6.47858 11.2791 8.12274C11.2791 9.76691 8.96415 11.0184 5.88957 11.0184ZM5.88957 6.45404C3.33344 6.45404 1.70572 7.4479 1.70572 8.12274C1.70572 8.79758 3.33344 9.79145 5.88957 9.79145C8.44569 9.79145 10.0734 8.79758 10.0734 8.12274C10.0734 7.4479 8.44569 6.45404 5.88957 6.45404Z"
      fill="currentColor" />
    <path
      d="M5.88957 14.5155C2.81498 14.5155 0.5 13.264 0.5 11.6198C0.5 11.2763 0.765258 11.0063 1.10286 11.0063C1.44046 11.0063 1.70572 11.2763 1.70572 11.6198C1.70572 12.307 3.33344 13.2885 5.88957 13.2885C8.44569 13.2885 10.0734 12.2947 10.0734 11.6198C10.0734 11.2763 10.3387 11.0063 10.6763 11.0063C11.0139 11.0063 11.2791 11.2763 11.2791 11.6198C11.2791 13.2763 8.96415 14.5155 5.88957 14.5155Z"
      fill="currentColor" />
    <path
      d="M5.88957 17.9999C2.81498 17.9999 0.5 16.7484 0.5 15.1042C0.5 14.7607 0.765258 14.4907 1.10286 14.4907C1.44046 14.4907 1.70572 14.7607 1.70572 15.1042C1.70572 15.7913 3.33344 16.7729 5.88957 16.7729C8.44569 16.7729 10.0734 15.7791 10.0734 15.1042C10.0734 14.7607 10.3387 14.4907 10.6763 14.4907C11.0139 14.4907 11.2791 14.7607 11.2791 15.1042C11.2791 16.7607 8.96415 17.9999 5.88957 17.9999Z"
      fill="currentColor" />
    <path
      d="M1.10286 15.9265C0.765258 15.9265 0.5 15.6566 0.5 15.313V9.00632C0.5 8.66276 0.765258 8.39282 1.10286 8.39282C1.44046 8.39282 1.70572 8.66276 1.70572 9.00632V15.313C1.70572 15.6566 1.44046 15.9265 1.10286 15.9265Z"
      fill="currentColor" />
    <path
      d="M10.6762 15.7178C10.3386 15.7178 10.0734 15.4479 10.0734 15.1043V8.12277C10.0734 7.77921 10.3386 7.50928 10.6762 7.50928C11.0138 7.50928 11.2791 7.77921 11.2791 8.12277V15.1043C11.2791 15.4479 11.0138 15.7178 10.6762 15.7178Z"
      fill="currentColor" />
    <path
      d="M11.1104 12.7607C10.7728 12.7607 10.5076 12.4907 10.5076 12.1472C10.5076 11.8036 10.7728 11.5337 11.1104 11.5337C13.6666 11.5337 15.2943 10.5398 15.2943 9.86496C15.2943 9.5214 15.5595 9.25146 15.8971 9.25146C16.2347 9.25146 16.5 9.5214 16.5 9.86496C16.5 11.5214 14.185 12.7607 11.1104 12.7607Z"
      fill="currentColor" />
    <path
      d="M11.1104 5.79139C8.03581 5.79139 5.72083 4.53986 5.72083 2.89569C5.72083 1.25153 8.03581 0 11.1104 0C14.185 0 16.5 1.25153 16.5 2.89569C16.5 4.53986 14.185 5.79139 11.1104 5.79139ZM11.1104 1.21472C8.55427 1.21472 6.92655 2.20858 6.92655 2.88343C6.92655 3.55827 8.55427 4.55213 11.1104 4.55213C13.6665 4.55213 15.2942 3.55827 15.2942 2.88343C15.2942 2.20858 13.6665 1.21472 11.1104 1.21472Z"
      fill="currentColor" />
    <path
      d="M11.1104 9.27628C10.7728 9.27628 10.5076 9.00634 10.5076 8.66278C10.5076 8.31923 10.7728 8.04929 11.1104 8.04929C13.6666 8.04929 15.2943 7.05543 15.2943 6.38058C15.2943 6.03703 15.5595 5.76709 15.8971 5.76709C16.2347 5.76709 16.5 6.03703 16.5 6.38058C16.5 8.03702 14.185 9.27628 11.1104 9.27628Z"
      fill="currentColor" />
    <path
      d="M11.1104 16.2577C10.7728 16.2577 10.5076 15.9878 10.5076 15.6442C10.5076 15.3007 10.7728 15.0307 11.1104 15.0307C13.6666 15.0307 15.2943 14.0369 15.2943 13.362C15.2943 13.0185 15.5595 12.7485 15.8971 12.7485C16.2347 12.7485 16.5 13.0185 16.5 13.362C16.5 15.0185 14.185 16.2577 11.1104 16.2577Z"
      fill="currentColor" />
    <path
      d="M15.897 13.9632C15.5594 13.9632 15.2942 13.6933 15.2942 13.3497V2.88351C15.2942 2.53996 15.5594 2.27002 15.897 2.27002C16.2347 2.27002 16.4999 2.53996 16.4999 2.88351V13.3497C16.4999 13.6933 16.2347 13.9632 15.897 13.9632Z"
      fill="currentColor" />
    <path
      d="M6.32369 6.45405C5.98608 6.45405 5.72083 6.18411 5.72083 5.84056V2.88351C5.72083 2.53996 5.98608 2.27002 6.32369 2.27002C6.66129 2.27002 6.92655 2.53996 6.92655 2.88351V5.84056C6.92655 6.18411 6.66129 6.45405 6.32369 6.45405Z"
      fill="currentColor" />
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedeemIcon {}

@Component({
  selector: 'arrow-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 7 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_393_3831)">
      <path
        d="M6.32 13.85C6.19 13.85 6.06 13.8 5.97 13.7L0.57 8.30001C-0.19 7.54001 -0.19 6.31001 0.57 5.55001L5.97 0.16001C6.17 -0.0399902 6.48 -0.0399902 6.68 0.16001C6.88 0.36001 6.88 0.67001 6.68 0.87001L1.27 6.26001C1.09 6.44001 0.99 6.68001 0.99 6.93001C0.99 7.18001 1.09 7.42001 1.27 7.60001L6.67 13C6.87 13.2 6.87 13.51 6.67 13.71C6.57 13.81 6.44 13.86 6.32 13.86V13.85Z"
        fill="currentColor" />
    </g>
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArrowIcon {}

@Component({
  selector: 'eye-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.3601 8.82005C6.7001 8.82005 5.3501 7.47005 5.3501 5.81005C5.3501 4.15005 6.7001 2.80005 8.3601 2.80005C10.0201 2.80005 11.3701 4.15005 11.3701 5.81005C11.3701 7.47005 10.0201 8.82005 8.3601 8.82005ZM8.3601 3.79005C7.2501 3.79005 6.3501 4.69005 6.3501 5.80005C6.3501 6.91005 7.2501 7.81005 8.3601 7.81005C9.4701 7.81005 10.3701 6.91005 10.3701 5.80005C10.3701 4.69005 9.4701 3.79005 8.3601 3.79005Z"
      fill="currentColor" />
    <path
      d="M8.36012 11.4801C5.37012 11.4801 2.58012 9.56013 0.500117 6.06013C0.410117 5.90013 0.410117 5.71013 0.500117 5.55013C2.58012 2.06013 5.37012 0.130127 8.36012 0.130127C11.3501 0.130127 14.1401 2.05013 16.2201 5.55013C16.3101 5.71013 16.3101 5.90013 16.2201 6.06013C14.1401 9.55013 11.3501 11.4801 8.36012 11.4801ZM1.51012 5.80013C3.38012 8.82013 5.80012 10.4701 8.35012 10.4701C10.9001 10.4701 13.3201 8.81013 15.1901 5.80013C13.3201 2.78013 10.9001 1.13013 8.35012 1.13013C5.80012 1.13013 3.38012 2.79013 1.51012 5.80013Z"
      fill="currentColor" />
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EyeIcon {}

@Component({
  selector: 'eye-off-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.80004 8.82005C7.14004 8.82005 5.79004 7.47005 5.79004 5.81005C5.79004 4.15005 7.14004 2.80005 8.80004 2.80005C10.46 2.80005 11.81 4.15005 11.81 5.81005C11.81 7.47005 10.46 8.82005 8.80004 8.82005ZM8.80004 3.79005C7.69004 3.79005 6.79004 4.69005 6.79004 5.80005C6.79004 6.91005 7.69004 7.81005 8.80004 7.81005C9.91004 7.81005 10.81 6.91005 10.81 5.80005C10.81 4.69005 9.91004 3.79005 8.80004 3.79005Z"
      fill="currentColor" />
    <path
      d="M8.80006 11.4801C5.81006 11.4801 3.02006 9.56013 0.940059 6.06013C0.850059 5.90013 0.850059 5.71013 0.940059 5.55013C3.02006 2.06013 5.81006 0.130127 8.80006 0.130127C11.7901 0.130127 14.5801 2.05013 16.6601 5.55013C16.7501 5.71013 16.7501 5.90013 16.6601 6.06013C14.5801 9.55013 11.7901 11.4801 8.80006 11.4801ZM1.96006 5.80013C3.83006 8.82013 6.25006 10.4701 8.80006 10.4701C11.3501 10.4701 13.7701 8.81013 15.6401 5.80013C13.7701 2.78013 11.3501 1.13013 8.80006 1.13013C6.25006 1.13013 3.83006 2.79013 1.96006 5.80013Z"
      fill="currentColor" />
    <path
      d="M3.57007 11.5401C3.44007 11.5401 3.31007 11.4901 3.22007 11.3901C3.02007 11.1901 3.02007 10.8801 3.22007 10.6801L13.6801 0.220068C13.8701 0.0200684 14.1901 0.0200684 14.3901 0.220068C14.5901 0.420068 14.5901 0.730068 14.3901 0.930068L3.93007 11.3901C3.83007 11.4901 3.70007 11.5401 3.58007 11.5401H3.57007Z"
      fill="currentColor" />
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EyeOffIcon {}

@Component({
  selector: 'clock-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.68003 14.3C3.74003 14.3 0.530029 11.09 0.530029 7.15C0.530029 3.21 3.74003 0 7.68003 0C11.62 0 14.83 3.21 14.83 7.15C14.83 11.09 11.62 14.3 7.68003 14.3ZM7.68003 1.01C4.29003 1.01 1.53003 3.77 1.53003 7.16C1.53003 10.55 4.29003 13.31 7.68003 13.31C11.07 13.31 13.83 10.55 13.83 7.16C13.83 3.77 11.07 1.01 7.68003 1.01Z"
      fill="currentColor" />
    <path
      d="M7.67993 7.65996C7.39993 7.65996 7.17993 7.43996 7.17993 7.15996V2.95996C7.17993 2.67996 7.39993 2.45996 7.67993 2.45996C7.95993 2.45996 8.17993 2.67996 8.17993 2.95996V7.14996C8.17993 7.42996 7.95993 7.64996 7.67993 7.64996V7.65996Z"
      fill="currentColor" />
    <path
      d="M10.0699 7.65991H7.67993C7.39993 7.65991 7.17993 7.43991 7.17993 7.15991C7.17993 6.87991 7.39993 6.65991 7.67993 6.65991H10.0699C10.3499 6.65991 10.5699 6.87991 10.5699 7.15991C10.5699 7.43991 10.3499 7.65991 10.0699 7.65991Z"
      fill="currentColor" />
  </svg> `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClockIcon {}

@Component({
  selector: 'chevron-down-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3538 1.35375L6.35378 6.35375C6.30734 6.40024 6.2522 6.43712 6.1915 6.46228C6.1308 6.48744 6.06574 6.50039 6.00003 6.50039C5.93432 6.50039 5.86926 6.48744 5.80856 6.46228C5.74786 6.43712 5.69271 6.40024 5.64628 6.35375L0.646278 1.35375C0.576272 1.28382 0.528588 1.1947 0.509263 1.09765C0.489938 1.00061 0.49984 0.900016 0.537716 0.808605C0.575593 0.717193 0.63974 0.639075 0.722036 0.58414C0.804333 0.529205 0.90108 0.499922 1.00003 0.5H11C11.099 0.499922 11.1957 0.529205 11.278 0.58414C11.3603 0.639075 11.4245 0.717193 11.4623 0.808605C11.5002 0.900016 11.5101 1.00061 11.4908 1.09765C11.4715 1.1947 11.4238 1.28382 11.3538 1.35375Z"
      fill="currentColor" />
  </svg>`
})
export class ChevronDownIcon {}

@Component({
  selector: 'check-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 11 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.77777 7.51136L10.0444 1.24448L8.8 0L3.77777 5.02239L1.24444 2.48897L0 3.73346L3.77777 7.51136Z"
      fill="currentColor" />
  </svg>`
})
export class CheckIcon {}

@Component({
  selector: 'close-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_828_5938)">
      <path
        d="M9.0063 18C4.04339 18 0 13.9566 0 8.9937C0 4.03079 4.04339 0 9.0063 0C13.9692 0 18.0126 4.04339 18.0126 9.0063C18.0126 13.9692 13.9692 18.0126 9.0063 18.0126V18ZM9.0063 1.25962C4.73618 1.25962 1.25962 4.73618 1.25962 9.0063C1.25962 13.2764 4.73618 16.753 9.0063 16.753C13.2764 16.753 16.753 13.2764 16.753 9.0063C16.753 4.73618 13.2764 1.25962 9.0063 1.25962Z"
        fill="currentColor" />
      <path
        d="M6.51225 11.4876C6.26032 11.2357 6.26032 10.8452 6.51225 10.5933L10.606 6.49949C10.8579 6.24757 11.2484 6.24757 11.5003 6.49949C11.7523 6.75141 11.7523 7.1419 11.5003 7.39382L7.40658 11.4876C7.15465 11.7395 6.76417 11.7395 6.51225 11.4876Z"
        fill="currentColor" />
      <path
        d="M10.606 11.4876L6.51225 7.39382C6.26032 7.1419 6.26032 6.75141 6.51225 6.49949C6.76417 6.24757 7.15465 6.24757 7.40658 6.49949L11.5003 10.5933C11.7523 10.8452 11.7523 11.2357 11.5003 11.4876C11.2484 11.7395 10.8579 11.7395 10.606 11.4876Z"
        fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_828_5938">
        <rect
          width="18"
          height="18"
          fill="white" />
      </clipPath>
    </defs>
  </svg> `
})
export class CloseIcon {}

@Component({
  selector: 'money-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.91488 5.03996C9.81383 5.03996 9.70015 5.0147 9.5991 4.95154C9.29594 4.7747 9.19489 4.39576 9.37173 4.0926L10.7486 1.71788C10.8243 1.57894 10.7738 1.45262 10.7486 1.41473C10.7233 1.3642 10.6475 1.26315 10.4833 1.26315H6.49175C6.32754 1.26315 6.25175 1.3642 6.22649 1.41473C6.20123 1.46525 6.1507 1.57894 6.22649 1.71788L7.60332 4.0926C7.78016 4.39576 7.67911 4.7747 7.37595 4.95154C7.0728 5.12838 6.69385 5.02733 6.51701 4.72417L5.14018 2.34946C4.86229 1.85683 4.86229 1.27578 5.14018 0.783152C5.41807 0.290524 5.93597 0 6.49175 0H10.4833C11.0517 0 11.557 0.290524 11.8349 0.783152C12.1128 1.27578 12.1128 1.85683 11.8349 2.34946L10.458 4.72417C10.3444 4.92628 10.1296 5.03996 9.91488 5.03996Z"
      fill="currentColor" />
    <path
      d="M6.59255 12.808C6.87044 12.808 7.12307 12.9848 7.21149 13.2374C7.36307 13.6669 7.72938 13.9574 8.44938 13.9574C9.16937 13.9574 9.64937 13.6164 9.64937 12.9469C9.64937 12.3153 9.29569 11.9743 8.19675 11.5954C6.54202 11.0269 5.85992 10.5217 5.85992 9.37221C5.85992 8.22275 6.87044 7.46486 8.38622 7.46486C9.63674 7.46486 10.3441 7.83117 10.6852 8.41222C10.9378 8.84169 10.5841 9.38484 10.0915 9.38484C9.81358 9.38484 9.57358 9.208 9.47253 8.95537C9.33358 8.61432 9.00516 8.37432 8.37359 8.37432C7.62833 8.37432 7.29991 8.74064 7.29991 9.29642C7.29991 9.85221 7.67886 10.1554 8.87885 10.5722C10.5083 11.128 11.1146 11.7596 11.1146 12.8332C11.1146 14.0585 10.2557 14.8669 8.41148 14.8669C7.07255 14.8669 6.31466 14.4501 5.97361 13.7932C5.73361 13.3511 6.07466 12.8206 6.56729 12.8206H6.60518L6.59255 12.808ZM7.90622 7.65433V7.25012C7.90622 6.94697 8.15885 6.69434 8.46201 6.69434C8.76517 6.69434 9.01779 6.94697 9.01779 7.25012V7.65433H7.90622ZM7.90622 15.1069V14.6395H9.01779V15.1069C9.01779 15.4101 8.76517 15.6627 8.46201 15.6627C8.15885 15.6627 7.90622 15.4101 7.90622 15.1069Z"
      fill="currentColor" />
    <path
      d="M10.9505 18.0001H6.0369C4.30638 18.0001 2.86639 17.3938 1.95693 16.2822C1.00957 15.1201 0.70641 13.5538 1.07272 11.7222C1.85587 7.86962 4.91269 3.71387 8.50003 3.71387C12.0874 3.71387 15.1442 7.86962 15.9273 11.7222C16.2937 13.5538 15.9905 15.1201 15.0431 16.2822C14.1337 17.3938 12.6811 18.0001 10.9632 18.0001H10.9505ZM8.4874 4.97702C5.89795 4.97702 3.0685 8.17278 2.29798 11.9749C2.00745 13.4148 2.22219 14.6275 2.91692 15.4864C3.58639 16.3075 4.66006 16.7496 6.02426 16.7496H10.9379C12.3021 16.7496 13.3758 16.3201 14.0453 15.4864C14.74 14.6275 14.9547 13.4148 14.6642 11.9749C13.8937 8.18541 11.0642 4.97702 8.47477 4.97702H8.4874Z"
      fill="currentColor" />
  </svg>`
})
export class MoneyIcon {}
@Component({
  selector: 'gift-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.7948 18.9994H3.89745C2.78207 18.9994 1.87183 18.0892 1.87183 16.9738V11.0893C1.87183 10.7303 2.15387 10.4482 2.51285 10.4482H16.1666C16.5255 10.4482 16.8076 10.7303 16.8076 11.0893V16.9738C16.8076 18.0892 15.8973 18.9994 14.782 18.9994H14.7948ZM3.16669 11.7303V16.9738C3.16669 17.3841 3.50001 17.7174 3.91027 17.7174H14.8076C15.2179 17.7174 15.5512 17.3841 15.5512 16.9738V11.7303H3.17951H3.16669Z"
      fill="currentColor" />
    <path
      d="M18.0511 11.7312H0.64102C0.282049 11.7312 0 11.4492 0 11.0902V8.88507C0 7.60303 1.03845 6.55176 2.33331 6.55176H16.3717C17.6537 6.55176 18.705 7.59021 18.705 8.88507V11.0902C18.705 11.4492 18.4229 11.7312 18.0639 11.7312H18.0511ZM1.28204 10.4492H17.4101V8.88507C17.4101 8.30815 16.9358 7.8338 16.3588 7.8338H2.32049C1.74358 7.8338 1.26922 8.30815 1.26922 8.88507V10.4492H1.28204Z"
      fill="currentColor" />
    <path
      d="M9.3461 19.0002C8.98713 19.0002 8.70508 18.7182 8.70508 18.3592V7.20547C8.70508 6.8465 8.98713 6.56445 9.3461 6.56445C9.70507 6.56445 9.98712 6.8465 9.98712 7.20547V18.3592C9.98712 18.7182 9.70507 19.0002 9.3461 19.0002Z"
      fill="currentColor" />
    <path
      d="M9.34612 7.84676C6.65383 7.84676 4.47437 5.65447 4.47437 2.975C4.47437 2.61603 4.75641 2.33398 5.11539 2.33398C5.47436 2.33398 5.75641 2.61603 5.75641 2.975C5.75641 4.96217 7.37177 6.56472 9.34612 6.56472C11.3205 6.56472 12.9358 4.94935 12.9358 2.975C12.9358 2.61603 13.2179 2.33398 13.5768 2.33398C13.9358 2.33398 14.2179 2.61603 14.2179 2.975C14.2179 5.66729 12.0256 7.84676 9.34612 7.84676Z"
      fill="currentColor" />
    <path
      d="M9.34616 7.84609C8.08976 7.84609 7.14105 6.37175 7.14105 4.42305C7.14105 2.47435 8.08976 1 9.34616 1C10.6026 1 11.5513 2.47435 11.5513 4.42305C11.5513 6.37175 10.6026 7.84609 9.34616 7.84609ZM9.34616 2.26922C8.97437 2.26922 8.42309 3.12819 8.42309 4.42305C8.42309 5.71791 8.97437 6.57687 9.34616 6.57687C9.71795 6.57687 10.2692 5.71791 10.2692 4.42305C10.2692 3.12819 9.71795 2.26922 9.34616 2.26922Z"
      fill="currentColor" />
  </svg>`
})
export class GiftIcon {}

@Component({
  selector: 'all-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 2 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 7C4.72936 7 4.45873 6.94253 4.21516 6.82759L0.358593 5.04598C0.135318 4.94381 0 4.73308 0 4.50319C0 4.27331 0.135318 4.06258 0.358593 3.96041L4.21516 2.17241C4.70907 1.94253 5.2977 1.94253 5.78484 2.17241L9.64141 3.95402C9.86468 4.05619 10 4.26692 10 4.49681C10 4.72669 9.86468 4.93742 9.64141 5.03959L5.78484 6.8212C5.54127 6.93614 5.27064 6.99361 5 6.99361V7ZM0.717185 4.49681L4.51286 6.25287C4.81732 6.39336 5.18268 6.39336 5.49391 6.25287L9.28958 4.49681L5.49391 2.74074C5.18945 2.60026 4.82409 2.60026 4.51286 2.74074L0.717185 4.49681Z"
      fill="currentColor" />
    <path
      d="M4.9966 12C4.72433 12 4.45886 11.9343 4.20701 11.8029L0.191007 9.69377C0.0208371 9.6062 -0.0472308 9.38725 0.0344507 9.2048C0.116132 9.02234 0.320336 8.94936 0.490505 9.03694L4.50651 11.1461C4.81962 11.3067 5.18038 11.3067 5.49349 11.1461L9.5095 9.03694C9.67966 8.94936 9.88387 9.02234 9.96555 9.2048C10.0472 9.38725 9.97916 9.6062 9.80899 9.69377L5.79299 11.8029C5.54114 11.9343 5.26887 12 4.9966 12Z"
      fill="currentColor" />
    <path
      d="M4.9966 10C4.72433 10 4.45886 9.93432 4.20701 9.80295L0.191007 7.69377C0.0208371 7.6062 -0.0472308 7.38725 0.0344507 7.2048C0.116132 7.02234 0.320336 6.94936 0.490505 7.03694L4.50651 9.14611C4.81962 9.30667 5.18038 9.30667 5.49349 9.14611L9.5095 7.03694C9.67966 6.94936 9.88387 7.02234 9.96555 7.2048C10.0472 7.38725 9.97916 7.6062 9.80899 7.69377L5.79299 9.80295C5.54114 9.93432 5.26887 10 4.9966 10Z"
      fill="currentColor" />
  </svg>`
})
export class AllIcon {}

@Component({
  selector: 'rounded-plus-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M5.5035 10C2.74633 10 0.5 7.75367 0.5 4.9965C0.5 2.23933 2.74633 0 5.5035 0C8.26067 0 10.507 2.24633 10.507 5.0035C10.507 7.76067 8.26067 10.007 5.5035 10.007V10ZM5.5035 0.69979C3.13121 0.69979 1.19979 2.63121 1.19979 5.0035C1.19979 7.37579 3.13121 9.30721 5.5035 9.30721C7.87579 9.30721 9.80721 7.37579 9.80721 5.0035C9.80721 2.63121 7.87579 0.69979 5.5035 0.69979Z"
        fill="currentColor" />
      <path
        d="M5.50391 3.03711C5.69954 3.03734 5.85337 3.19106 5.85352 3.38672V4.65332H7.10645C7.30219 4.65353 7.45605 4.8081 7.45605 5.00391C7.45582 5.1995 7.30204 5.3533 7.10645 5.35352H5.85352V6.60645C5.8533 6.80204 5.6995 6.95582 5.50391 6.95605C5.3081 6.95605 5.15353 6.80219 5.15332 6.60645V5.35352H3.88672C3.69106 5.35337 3.53734 5.19954 3.53711 5.00391C3.53711 4.80806 3.69091 4.65347 3.88672 4.65332H5.15332V3.38672C5.15347 3.19091 5.30806 3.03711 5.50391 3.03711Z"
        fill="currentColor" />
    </g>
  </svg>`
})
export class RoundedPlusIcon {}

@Component({
  selector: 'rounded-minus-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M5.5035 10C2.74633 10 0.5 7.75367 0.5 4.9965C0.5 2.23933 2.74633 0 5.5035 0C8.26067 0 10.507 2.24633 10.507 5.0035C10.507 7.76067 8.26067 10.007 5.5035 10.007V10ZM5.5035 0.69979C3.13121 0.69979 1.19979 2.63121 1.19979 5.0035C1.19979 7.37579 3.13121 9.30721 5.5035 9.30721C7.87579 9.30721 9.80721 7.37579 9.80721 5.0035C9.80721 2.63121 7.87579 0.69979 5.5035 0.69979Z"
        fill="currentColor" />
      <path
        d="M7.10602 5.35311H3.88699C3.69105 5.35311 3.53709 5.19916 3.53709 5.00322C3.53709 4.80727 3.69105 4.65332 3.88699 4.65332H7.10602C7.30196 4.65332 7.45592 4.80727 7.45592 5.00322C7.45592 5.19916 7.30196 5.35311 7.10602 5.35311Z"
        fill="currentColor" />
    </g>
  </svg>`
})
export class RoundedMinusIcon {}

@Component({
  selector: 'profile-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.2433 18.0009H1.76754C1.22936 18.0009 0.728727 17.7712 0.3908 17.3602C0.0528723 16.9491 -0.0722857 16.4172 0.0403567 15.8974C0.753759 12.7664 3.68246 10.5059 6.99915 10.5059C10.3158 10.5059 13.2446 12.7785 13.958 15.8974C14.0706 16.4172 13.958 16.9491 13.6075 17.3602C13.2696 17.7591 12.7689 18.0009 12.2308 18.0009H12.2433ZM6.99915 11.7268C4.25819 11.7268 1.84264 13.6006 1.25439 16.1755C1.21684 16.3326 1.25439 16.4898 1.35452 16.6227C1.4171 16.6953 1.54226 16.8041 1.75502 16.8041H12.2308C12.4435 16.8041 12.5687 16.6832 12.6313 16.6227C12.7314 16.5019 12.769 16.3326 12.7314 16.1755C12.1432 13.6006 9.7276 11.7268 6.98664 11.7268H6.99915Z"
      fill="currentColor" />
    <path
      d="M6.99901 8.8731C4.47081 8.8731 2.4057 6.87847 2.4057 4.43655C2.4057 1.99464 4.47081 0 6.99901 0C9.5272 0 11.5923 1.99464 11.5923 4.43655C11.5923 6.87847 9.5272 8.8731 6.99901 8.8731ZM6.99901 1.20887C5.15918 1.20887 3.65728 2.65951 3.65728 4.43655C3.65728 6.21359 5.15918 7.66423 6.99901 7.66423C8.83883 7.66423 10.3407 6.21359 10.3407 4.43655C10.3407 2.65951 8.83883 1.20887 6.99901 1.20887Z"
      fill="currentColor" />
  </svg>`
})
export class ProfileIcon {}

@Component({
  selector: 'question-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.3317 10.9346C6.10778 10.9346 5.90875 10.8588 5.74704 10.7071C5.58532 10.5554 5.49825 10.3153 5.49825 10.0119C5.49825 9.43042 5.7968 9.08913 6.31926 9.08913C6.64268 9.08913 6.82928 9.22818 6.94123 9.34194C7.09051 9.50627 7.15271 9.72116 7.15271 9.99925C7.15271 10.2773 7.07807 10.4922 6.94123 10.6565C6.79196 10.8335 6.58049 10.922 6.31926 10.922L6.3317 10.9346ZM6.00827 8.74784C5.85899 8.74784 5.74704 8.62143 5.74704 8.48239V8.22958C5.74704 7.82509 5.80924 7.47115 5.94607 7.2057C6.07047 6.92761 6.30682 6.64952 6.64268 6.35879C7.14027 5.92901 7.32686 5.71412 7.38906 5.60036C7.47613 5.46131 7.51345 5.28435 7.51345 5.0821C7.51345 4.84193 7.43882 4.66497 7.30198 4.53856C7.15271 4.41216 6.90391 4.33631 6.59293 4.33631C6.36901 4.33631 6.1451 4.3616 5.93363 4.41216C5.72216 4.46272 5.47337 4.56384 5.18726 4.71553C5.14994 4.74081 5.11262 4.74081 5.06286 4.74081C5.03798 4.74081 5.00067 4.74081 4.97579 4.72817C4.90115 4.70289 4.85139 4.65233 4.82651 4.57648L4.55284 3.93182C4.49065 3.80541 4.55284 3.65373 4.67724 3.57789C5.29922 3.24923 5.97095 3.07227 6.64268 3.07227C7.31442 3.07227 7.82444 3.24923 8.21007 3.59053C8.59569 3.94446 8.79472 4.43744 8.79472 5.05682C8.79472 5.30963 8.75741 5.5498 8.68277 5.75205C8.60813 5.95429 8.50861 6.1439 8.37178 6.32087C8.23494 6.49784 7.97371 6.75064 7.57565 7.11722C7.2149 7.43323 7.06563 7.62284 7.00343 7.72396C6.92879 7.863 6.89148 8.06525 6.89148 8.30542V8.45711C6.89148 8.60879 6.76708 8.72256 6.63024 8.72256H6.03315L6.00827 8.74784Z"
      fill="currentColor" />
    <path
      d="M6.64271 13.5H0.621977C0.27367 13.5 0 13.2219 0 12.868V6.75001C0 3.03371 2.98549 0 6.64271 0C10.2999 0 13.2854 3.03371 13.2854 6.75001C13.2854 10.4663 10.2999 13.5 6.64271 13.5ZM1.24395 12.236H6.64271C9.61576 12.236 12.0415 9.77108 12.0415 6.75001C12.0415 3.72894 9.61576 1.26405 6.64271 1.26405C3.66966 1.26405 1.24395 3.72894 1.24395 6.75001V12.236Z"
      fill="currentColor" />
    <path
      d="M17.3656 17.9993H11.3448C9.67794 17.9993 8.08568 17.3673 6.85417 16.2297C6.60538 15.9895 6.5805 15.5976 6.81685 15.3322C7.0532 15.0794 7.43882 15.0541 7.70005 15.2943C8.69522 16.2297 10.0014 16.7353 11.3448 16.7353H16.7436V11.2493C16.7436 9.75774 16.1589 8.35465 15.1016 7.30549C14.8528 7.06532 14.8528 6.66082 15.0891 6.40801C15.3255 6.15521 15.7236 6.1552 15.9723 6.39537C17.2785 7.6847 18 9.4038 18 11.2367V17.3547C18 17.7086 17.7263 17.9867 17.378 17.9867L17.3656 17.9993Z"
      fill="currentColor" />
  </svg>`
})
export class QuestionIcon {}

@Component({
  selector: 'whatsapp-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.7245 10.1819C14.293 10.587 14.2005 11.4782 13.5658 11.7618C12.0982 12.4369 10.3264 12.1534 9.12324 10.9246L6.73006 8.48044C5.52686 7.25164 5.26242 5.44219 5.9103 3.94331C6.18796 3.29515 7.06061 3.20062 7.45727 3.78127L8.13159 4.74001C8.32992 5.02358 8.34314 5.40168 8.18448 5.71225C7.86715 6.34691 7.97293 7.14361 8.50181 7.68374L9.91656 9.12861C10.4322 9.65524 11.2123 9.76327 11.847 9.45269C12.1511 9.29065 12.5213 9.30415 12.799 9.5067L13.7377 10.1954L13.7245 10.1819Z"
      fill="currentColor" />
    <path
      d="M9.50661 18C8.71329 18 7.97286 17.6894 7.41754 17.1088L6.135 15.7989C5.8309 15.4884 5.40779 15.3128 4.97147 15.3128H2.96173C1.3222 15.3128 0 13.9625 0 12.2881V3.02476C0 1.35034 1.3222 0 2.96173 0H16.0383C17.6778 0 19 1.35034 19 3.02476V12.2881C19 13.9625 17.6778 15.3128 16.0383 15.3128H14.0285C13.5922 15.3128 13.1823 15.4884 12.865 15.7989L11.5825 17.1088C11.0271 17.6759 10.2735 18 9.49339 18H9.50661ZM2.96173 1.35034C2.06263 1.35034 1.3222 2.10653 1.3222 3.02476V12.2881C1.3222 13.2063 2.06263 13.9625 2.96173 13.9625H4.97147C5.76479 13.9625 6.50522 14.2731 7.06054 14.8537L8.34308 16.1635C8.64718 16.4741 9.07028 16.6497 9.50661 16.6497C9.94294 16.6497 10.3528 16.4741 10.6701 16.1635L11.9527 14.8537C12.508 14.2866 13.2617 13.9625 14.0418 13.9625H16.0515C16.9506 13.9625 17.691 13.2063 17.691 12.2881V3.02476C17.691 2.10653 16.9506 1.35034 16.0515 1.35034H2.96173Z"
      fill="currentColor" />
  </svg>`
})
export class WhatsAppIcon {}

@Component({
  selector: 'terms-icon',
  template: `
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.64852 3.54539C3.64852 3.54539 3.55859 3.54539 3.52005 3.5324C3.48151 3.5324 3.44298 3.50643 3.40444 3.49344C3.3659 3.48046 3.32736 3.45448 3.28882 3.4285C3.25028 3.40253 3.22458 3.37656 3.18605 3.35059C3.16035 3.32461 3.13466 3.28565 3.10897 3.24669C3.08327 3.20773 3.07043 3.16876 3.04473 3.1298C3.03189 3.09084 3.01904 3.05188 3.00619 3.01292C3.00619 2.97396 2.99335 2.92201 2.99335 2.88305C2.99335 2.84409 2.99335 2.79214 3.00619 2.75318C3.00619 2.71422 3.03189 2.67526 3.04473 2.6363C3.05758 2.59733 3.08327 2.55838 3.10897 2.51942C3.13466 2.48046 3.16035 2.45448 3.18605 2.41552C3.21174 2.38954 3.25028 2.36357 3.28882 2.3376C3.32736 2.31163 3.3659 2.29863 3.40444 2.27266C3.44298 2.25967 3.48151 2.24669 3.52005 2.2337C3.7256 2.19474 3.94399 2.25967 4.09815 2.41552C4.12384 2.44149 4.14953 2.48046 4.17523 2.51942C4.20092 2.55838 4.21377 2.59733 4.23946 2.6363C4.25231 2.67526 4.26515 2.71422 4.278 2.75318C4.278 2.79214 4.29085 2.84409 4.29085 2.88305C4.29085 3.05188 4.22661 3.22071 4.09815 3.3376C4.07245 3.36357 4.03392 3.38954 3.99538 3.41551C3.95684 3.44149 3.9183 3.45448 3.87976 3.48045C3.84122 3.49344 3.80268 3.50643 3.76414 3.51941C3.7256 3.51941 3.68706 3.5324 3.63567 3.5324L3.64852 3.54539Z"
        fill="currentColor" />
      <path
        d="M6.84728 3.54539C6.84728 3.54539 6.75736 3.54539 6.71882 3.5324C6.68028 3.5324 6.64174 3.50643 6.6032 3.49344C6.56466 3.48046 6.52612 3.45448 6.48758 3.4285C6.44904 3.40253 6.42335 3.37656 6.38481 3.35059C6.35911 3.32461 6.33342 3.28565 6.30773 3.24669C6.28204 3.20773 6.26919 3.16876 6.2435 3.1298C6.23065 3.09084 6.2178 3.05188 6.20496 3.01292C6.20496 2.97396 6.20496 2.92201 6.20496 2.88305C6.20496 2.84409 6.20496 2.79214 6.20496 2.75318C6.20496 2.71422 6.23065 2.67526 6.2435 2.6363C6.25634 2.59733 6.28204 2.55838 6.30773 2.51942C6.33342 2.48046 6.35911 2.45448 6.38481 2.41552C6.4105 2.38954 6.44904 2.36357 6.48758 2.3376C6.52612 2.31163 6.56466 2.29863 6.6032 2.27266C6.64174 2.25967 6.68028 2.24669 6.71882 2.2337C6.92436 2.19474 7.1556 2.25967 7.29691 2.41552C7.41253 2.5324 7.48961 2.70123 7.48961 2.87006C7.48961 3.03889 7.42538 3.20772 7.29691 3.32461C7.27122 3.35058 7.23268 3.37656 7.19414 3.40253C7.1556 3.42851 7.11706 3.44149 7.07852 3.46746C7.03998 3.48045 7.00144 3.49344 6.9629 3.50642C6.92436 3.50642 6.88582 3.51941 6.83444 3.51941L6.84728 3.54539Z"
        fill="currentColor" />
      <path
        d="M10.0461 3.54607C9.87907 3.54607 9.71206 3.48114 9.59644 3.35127C9.48083 3.23438 9.40375 3.06555 9.40375 2.89672C9.40375 2.85776 9.40375 2.80581 9.40375 2.76685C9.40375 2.72788 9.42944 2.68893 9.44229 2.64997C9.45513 2.61101 9.48083 2.57204 9.50652 2.53308C9.53221 2.49412 9.55791 2.46815 9.5836 2.42919C9.73776 2.27335 9.95615 2.20841 10.1617 2.24737C10.2002 2.24737 10.2388 2.27335 10.2773 2.28633C10.3159 2.29932 10.3544 2.32529 10.3929 2.35126C10.4315 2.37724 10.4572 2.40322 10.4957 2.42919C10.5214 2.45516 10.5471 2.49412 10.5728 2.53308C10.5985 2.57204 10.6113 2.61101 10.637 2.64997C10.6499 2.68893 10.6627 2.72788 10.6756 2.76685C10.6756 2.80581 10.6756 2.85776 10.6756 2.89672C10.6756 3.06555 10.6113 3.23438 10.4829 3.35127C10.3672 3.46815 10.2002 3.54607 10.0332 3.54607H10.0461Z"
        fill="currentColor" />
      <path
        d="M17.0473 18H1.95267C0.873563 18 0 17.1169 0 16.026V1.97402C0 0.883113 0.873563 0 1.95267 0H17.0473C18.1264 0 19 0.883113 19 1.97402V16.026C19 17.1169 18.1264 18 17.0473 18ZM1.95267 1.2987C1.58012 1.2987 1.28465 1.5974 1.28465 1.97402V16.026C1.28465 16.4026 1.58012 16.7013 1.95267 16.7013H17.0473C17.4199 16.7013 17.7153 16.4026 17.7153 16.026V1.97402C17.7153 1.5974 17.4199 1.2987 17.0473 1.2987H1.95267Z"
        fill="currentColor" />
      <path
        d="M18.3448 5.77917H0.642326C0.282623 5.77917 0 5.49346 0 5.12982C0 4.76618 0.282623 4.48047 0.642326 4.48047H18.3577C18.7174 4.48047 19 4.76618 19 5.12982C19 5.49346 18.7174 5.77917 18.3577 5.77917H18.3448Z"
        fill="currentColor" />
      <path
        d="M13.9256 9.64831H5.06145C4.70175 9.64831 4.41913 9.3626 4.41913 8.99896C4.41913 8.63532 4.70175 8.34961 5.06145 8.34961H13.9256C14.2853 8.34961 14.5679 8.63532 14.5679 8.99896C14.5679 9.3626 14.2853 9.64831 13.9256 9.64831Z"
        fill="currentColor" />
      <path
        d="M9.77613 13.5194H5.06145C4.70175 13.5194 4.41913 13.2337 4.41913 12.8701C4.41913 12.5064 4.70175 12.2207 5.06145 12.2207H9.77613C10.1358 12.2207 10.4185 12.5064 10.4185 12.8701C10.4185 13.2337 10.1358 13.5194 9.77613 13.5194Z"
        fill="currentColor" />
    </svg>
  `
})
export class TermsIcon {}

@Component({
  selector: 'sign-out-icon',
  template: `
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.027 12.7988C12.8713 12.7988 12.7156 12.7386 12.6078 12.6182C12.3683 12.3774 12.3683 12.0042 12.6078 11.7634L15.2785 9.07842C15.2785 9.07842 15.3264 8.95802 15.2785 8.90985L12.6078 6.2249C12.3683 5.9841 12.3683 5.61086 12.6078 5.37006C12.8353 5.12925 13.2186 5.12925 13.4581 5.37006L16.1288 8.05501C16.6437 8.57273 16.6437 9.4035 16.1288 9.92123L13.4581 12.6062C13.3383 12.7266 13.1827 12.7868 13.0389 12.7868L13.027 12.7988Z"
        fill="currentColor" />
      <path
        d="M15.9012 9.59659H4.45207C4.11674 9.59659 3.85327 9.33171 3.85327 8.99458C3.85327 8.65746 4.11674 8.39258 4.45207 8.39258H15.9012C16.2365 8.39258 16.5 8.65746 16.5 8.99458C16.5 9.33171 16.2365 9.59659 15.9012 9.59659Z"
        fill="currentColor" />
      <path
        d="M5.42216 18H3.18263C1.6976 18 0.5 16.796 0.5 15.303V2.69699C0.5 1.20401 1.6976 0 3.18263 0H5.42216C5.75748 0 6.02096 0.264883 6.02096 0.602007C6.02096 0.93913 5.75748 1.20401 5.42216 1.20401H3.18263C2.36826 1.20401 1.6976 1.87826 1.6976 2.69699V15.303C1.6976 16.1217 2.36826 16.796 3.18263 16.796H5.42216C5.75748 16.796 6.02096 17.0609 6.02096 17.398C6.02096 17.7351 5.75748 18 5.42216 18Z"
        fill="currentColor" />
    </svg>
  `
})
export class SignOutIcon {}

@Component({
  selector: 'delete-icon',
  template: `
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M12.011 3.41265H0.988998C0.715159 3.41265 0.5 3.19876 0.5 2.92654C0.5 2.65432 0.715159 2.44043 0.988998 2.44043H12.011C12.2848 2.44043 12.5 2.65432 12.5 2.92654C12.5 3.19876 12.2848 3.41265 12.011 3.41265Z"
          fill="currentColor" />
        <path
          d="M9.78118 14.0002H3.21883C2.54402 14.0002 1.99634 13.4558 1.99634 12.7849V2.93631C1.99634 2.66408 2.2115 2.4502 2.48534 2.4502H10.5147C10.7885 2.4502 11.0037 2.66408 11.0037 2.93631V12.7946C11.0037 13.4655 10.456 14.0099 9.78118 14.0099V14.0002ZM2.97433 3.4127V12.7849C2.97433 12.921 3.08191 13.028 3.21883 13.028H9.78118C9.9181 13.028 10.0257 12.921 10.0257 12.7849V3.4127H2.97433Z"
          fill="currentColor" />
        <path
          d="M9.2238 3.4125H3.76659C3.49275 3.4125 3.27759 3.19861 3.27759 2.92639V1.54583C3.27759 0.690278 3.97196 0 4.8326 0H8.15778C9.01842 0 9.7128 0.690278 9.7128 1.54583V2.92639C9.7128 3.19861 9.49764 3.4125 9.2238 3.4125ZM4.25558 2.45H8.7348V1.54583C8.7348 1.225 8.47074 0.972222 8.15778 0.972222H4.8326C4.50986 0.972222 4.25558 1.23472 4.25558 1.54583V2.45Z"
          fill="currentColor" />
        <path
          d="M7.83494 10.2669C7.56111 10.2669 7.34595 10.053 7.34595 9.78077V6.65994C7.34595 6.38772 7.56111 6.17383 7.83494 6.17383C8.10878 6.17383 8.32394 6.38772 8.32394 6.65994V9.78077C8.32394 10.053 8.10878 10.2669 7.83494 10.2669Z"
          fill="currentColor" />
        <path
          d="M5.16502 10.2669C4.89118 10.2669 4.67603 10.053 4.67603 9.78077V6.65994C4.67603 6.38772 4.89118 6.17383 5.16502 6.17383C5.43886 6.17383 5.65402 6.38772 5.65402 6.65994V9.78077C5.65402 10.053 5.43886 10.2669 5.16502 10.2669Z"
          fill="currentColor" />
      </g>
    </svg>
  `
})
export class DeleteIcon {}

@Component({
  selector: 'camera-icon',
  template: `
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M13.6 14.3355H1.39996C0.739961 14.3355 0.209961 13.8055 0.209961 13.1455V4.35547C0.209961 3.66547 0.769961 3.10547 1.45996 3.10547H13.53C14.22 3.10547 14.78 3.66547 14.78 4.35547V13.1455C14.78 13.8055 14.25 14.3355 13.59 14.3355H13.6ZM1.45996 4.09547C1.31996 4.09547 1.19996 4.20547 1.19996 4.35547V13.1455C1.19996 13.2455 1.28996 13.3355 1.38996 13.3355H13.59C13.69 13.3355 13.78 13.2555 13.78 13.1455V4.35547C13.78 4.21547 13.67 4.09547 13.52 4.09547H1.45996Z"
          fill="currentColor" />
        <path
          d="M7.49999 11.7251C5.83999 11.7251 4.48999 10.3751 4.48999 8.71508C4.48999 7.05508 5.83999 5.70508 7.49999 5.70508C9.15999 5.70508 10.51 7.05508 10.51 8.71508C10.51 10.3751 9.15999 11.7251 7.49999 11.7251ZM7.49999 6.70508C6.38999 6.70508 5.48999 7.60508 5.48999 8.71508C5.48999 9.82508 6.38999 10.7251 7.49999 10.7251C8.60999 10.7251 9.50999 9.82508 9.50999 8.71508C9.50999 7.60508 8.60999 6.70508 7.49999 6.70508Z"
          fill="currentColor" />
        <path
          d="M10.78 4.09527H4.23001C4.06001 4.09527 3.91001 4.01527 3.82001 3.87527C3.73001 3.73527 3.71001 3.56527 3.77001 3.40527L4.45001 1.72527C4.71001 1.07527 5.33001 0.655273 6.03001 0.655273H8.99001C9.69001 0.655273 10.31 1.07527 10.57 1.72527L11.25 3.40527C11.31 3.55527 11.29 3.73527 11.2 3.87527C11.11 4.01527 10.95 4.09527 10.79 4.09527H10.78ZM4.96001 3.09527H10.03L9.63001 2.10527C9.52001 1.83527 9.26002 1.66527 8.97002 1.66527H6.01001C5.72001 1.66527 5.46001 1.83527 5.35001 2.10527L4.95001 3.09527H4.96001Z"
          fill="currentColor" />
      </g>
    </svg>
  `
})
export class CameraIcon {}

@Component({
  selector: 'timer-icon',
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 16 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="8"
      cy="9.375"
      r="4.875"
      stroke="currentColor"
      stroke-width="1.25" />
    <circle
      cx="8"
      cy="9.375"
      r="0.5"
      fill="currentColor" />
    <path
      d="M7.75 4.875 L8.25 4.875 L8.25 9.25 L7.75 9.25 Z"
      fill="currentColor" />
    <rect
      x="6.25"
      y="0.875"
      width="3.5"
      height="1.75"
      rx="0.375"
      fill="currentColor" />
    <rect
      x="12.875"
      y="8.75"
      width="1.25"
      height="1.25"
      transform="rotate(45 12.875 8.75)"
      fill="currentColor" />
  </svg>`
})
export class TimerIcon {}

@Component({
  selector: 'flash-icon',
  template: `
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.94701 14C2.77365 14 2.6003 13.9575 2.42694 13.8725C1.95249 13.626 1.76088 13.1245 1.96161 12.657L3.78643 8.4493H1.04008C0.702487 8.4493 0.392268 8.3048 0.200662 8.04979C-6.75746e-05 7.79478 -0.0548121 7.48027 0.0546769 7.18276L2.30833 0.671524C2.44519 0.27201 2.84665 0 3.30285 0H6.89774C7.24446 0 7.5638 0.161506 7.76453 0.425015C7.95614 0.697025 7.99263 1.02854 7.8649 1.33455L6.56015 4.33516H8.95979C9.35212 4.33516 9.70796 4.53916 9.89044 4.86217C10.0729 5.19369 10.0364 5.5762 9.80833 5.87371L3.78643 13.5835C3.57657 13.847 3.27548 13.9915 2.95614 13.9915L2.94701 14ZM3.29373 0.85003C3.23898 0.85003 3.18424 0.884032 3.16599 0.935034L0.912341 7.44627C0.894093 7.49727 0.912341 7.53977 0.930589 7.55677C0.948837 7.57377 0.97621 7.60777 1.04008 7.60777H4.46161C4.61672 7.60777 4.75358 7.67577 4.8357 7.79478C4.91782 7.91378 4.93606 8.05829 4.88132 8.19429L2.81015 12.98C2.81015 12.98 2.76453 13.082 2.8649 13.133C2.96526 13.184 3.02001 13.1245 3.03825 13.099L9.06015 5.38919C9.09665 5.33819 9.08752 5.29569 9.06927 5.26169C9.05103 5.22769 9.01453 5.19369 8.95066 5.19369H5.87584C5.72074 5.19369 5.58387 5.12568 5.50176 5.00668C5.41964 4.88767 5.40139 4.74317 5.45614 4.60716L7.00723 1.02004C7.02548 0.969035 7.00723 0.926533 6.99811 0.909533C6.97986 0.892532 6.95249 0.858531 6.88862 0.858531H3.29373V0.85003Z"
        fill="currentColor" />
    </svg>
  `
})
export class FlashIcon {}

@Component({
  selector: 'impulse-icon',
  template: `
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M6.75822 13.9998C3.30512 13.9998 0.5 11.1947 0.5 7.74162C0.5 4.28851 3.30512 1.4834 6.75822 1.4834C7.76431 1.4834 8.7704 1.73066 9.65713 2.19107C9.8447 2.29339 9.92144 2.52359 9.81912 2.71117C9.71681 2.89875 9.4866 2.97548 9.29903 2.87317C8.52314 2.46391 7.64495 2.25076 6.75822 2.25076C3.73143 2.25076 1.27588 4.71482 1.27588 7.74162C1.27588 10.7684 3.73995 13.2325 6.76675 13.2325C9.79354 13.2325 12.2576 10.7684 12.2576 7.74162C12.2576 6.84637 12.0445 5.99375 11.6352 5.20082C11.5329 5.01324 11.6096 4.78303 11.7972 4.68072C11.9848 4.5784 12.215 4.65514 12.3173 4.84272C12.7777 5.72944 13.025 6.73553 13.025 7.74162C13.025 11.1947 10.2199 13.9998 6.76675 13.9998H6.75822Z"
          fill="currentColor" />
        <path
          d="M6.75822 12.048C4.38794 12.048 2.4525 10.1211 2.4525 7.74225C2.4525 5.36344 4.37941 3.43652 6.75822 3.43652C7.21863 3.43652 7.67052 3.50473 8.10536 3.64968C8.30999 3.71789 8.42083 3.93104 8.35262 4.13567C8.28441 4.3403 8.07125 4.45114 7.86662 4.38293C7.50852 4.26356 7.1419 4.20388 6.75822 4.20388C4.81425 4.20388 3.22838 5.78975 3.22838 7.73372C3.22838 9.67769 4.81425 11.2636 6.75822 11.2636C8.70219 11.2636 10.2881 9.67769 10.2881 7.73372C10.2881 7.35004 10.2284 6.98342 10.109 6.62532C10.0408 6.42069 10.1516 6.20753 10.3563 6.13932C10.5609 6.07111 10.7741 6.18196 10.8423 6.38658C10.9872 6.82142 11.0554 7.27331 11.0554 7.73372C11.0554 10.104 9.1285 12.0394 6.74969 12.0394L6.75822 12.048Z"
          fill="currentColor" />
        <path
          d="M6.75822 10.0864C5.46224 10.0864 4.41352 9.03771 4.41352 7.74173C4.41352 6.74417 5.04446 5.85744 5.98234 5.53345C6.16139 5.46524 6.36602 5.54198 6.45981 5.72103C6.55359 5.9086 6.47686 6.13881 6.28928 6.24112C6.28928 6.24112 6.25518 6.25818 6.23812 6.2667C5.60719 6.48838 5.18088 7.07669 5.18088 7.75026C5.18088 8.61993 5.88855 9.31908 6.7497 9.31908C7.42326 9.31908 8.0201 8.89277 8.23325 8.26183C8.30146 8.0572 8.52314 7.95489 8.72777 8.0231C8.9324 8.09131 9.03471 8.31299 8.9665 8.51761C8.64251 9.4555 7.74726 10.095 6.7497 10.095L6.75822 10.0864Z"
          fill="currentColor" />
        <path
          d="M12.505 0.0078125C12.6328 0.0333957 12.7351 0.118973 12.7863 0.238281L13.213 1.27832L14.253 1.70508C14.3722 1.75628 14.457 1.85855 14.4825 1.98633C14.5081 2.11417 14.4662 2.24216 14.381 2.33594L13.5792 3.1377C13.2723 3.44451 12.8712 3.59766 12.462 3.59766L12.4708 3.60645C12.1927 3.60645 11.9115 3.53063 11.6622 3.38281L7.03137 8.01465C6.95463 8.09138 6.86025 8.125 6.75793 8.125C6.65578 8.12493 6.56211 8.09124 6.48547 8.01465C6.332 7.86118 6.332 7.62222 6.48547 7.46875L11.1154 2.83789C10.9712 2.59693 10.8937 2.32158 10.8937 2.0293C10.8937 1.60308 11.0553 1.2105 11.3536 0.912109L12.1554 0.110352C12.2492 0.0166479 12.3772 -0.0177559 12.505 0.0078125ZM11.8995 1.45801C11.7462 1.61146 11.6613 1.81623 11.6613 2.0293C11.6614 2.2423 11.7462 2.44721 11.8995 2.60059H11.9083C12.2238 2.91563 12.7353 2.91574 13.0421 2.60059L13.4347 2.20801L12.7775 1.93555C12.6837 1.89291 12.6072 1.82398 12.5646 1.72168L12.2921 1.06543L11.8995 1.45801Z"
          fill="currentColor" />
      </g>
    </svg>
  `
})
export class ImpulseIcon {}

@Component({
  selector: 'memory-icon',
  template: `
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.042 0C13.8435 0 14.5 0.656546 14.5 1.45801V7C14.5 7.03684 14.4929 7.07184 14.4834 7.10547V12.542C14.4834 13.3433 13.8267 13.9998 13.0254 14H1.95801C1.15655 14 0.5 13.3435 0.5 12.542V1.45801C0.5 0.656546 1.15655 0 1.95801 0H13.042ZM6.10156 7.38379C5.92246 8.27897 5.12098 8.93555 4.2002 8.93555L4.19141 8.94434C3.27085 8.94413 2.46917 8.28755 2.29004 7.39258H1.26758V12.542C1.26758 12.9257 1.57433 13.2324 1.95801 13.2324H7.11621V12.2354C7.11621 11.8603 7.38038 11.5359 7.73828 11.459C8.28381 11.3482 8.67655 10.8626 8.67676 10.3086C8.67676 9.75439 8.28396 9.26807 7.73828 9.15723C7.38039 9.08033 7.11621 8.75587 7.11621 8.38086V7.38379H6.10156ZM10.8086 5.82324C10.2544 5.82324 9.76807 6.21604 9.65723 6.76172C9.58033 7.11961 9.25587 7.38379 8.88086 7.38379H7.88379V8.39844C8.77897 8.57754 9.43555 9.37902 9.43555 10.2998C9.43547 11.2205 8.77895 12.0221 7.88379 12.2012V13.2324H13.042C13.4257 13.2324 13.7324 12.9257 13.7324 12.542V7.38379H12.7354C12.3603 7.38379 12.0359 7.11962 11.959 6.76172C11.8482 6.21619 11.3626 5.82345 10.8086 5.82324ZM1.95801 0.776367C1.57433 0.776367 1.26758 1.08312 1.26758 1.4668V6.625L1.27637 6.61621H2.27344C2.64847 6.61621 2.97294 6.88035 3.0498 7.23828C3.16063 7.7839 3.64606 8.17668 4.2002 8.17676C4.7544 8.17676 5.24072 7.78396 5.35156 7.23828C5.42846 6.88052 5.7521 6.61637 6.12695 6.61621H7.125V5.60156C6.22975 5.42251 5.57324 4.62102 5.57324 3.7002C5.57332 2.77944 6.22128 1.97787 7.125 1.79883V0.776367H1.95801ZM7.88379 1.76465C7.88379 2.13966 7.61962 2.46413 7.26172 2.54102C6.72471 2.65183 6.33224 3.13738 6.33203 3.69141C6.33203 4.24561 6.72457 4.73193 7.26172 4.84277C7.61961 4.91967 7.88379 5.24413 7.88379 5.61914V6.61621H8.89844C9.07754 5.72103 9.87902 5.06445 10.7998 5.06445C11.7205 5.06453 12.5221 5.72105 12.7012 6.61621H13.7324V1.45801C13.7324 1.07433 13.4257 0.767578 13.042 0.767578H7.88379V1.76465Z"
        fill="currentColor" />
    </svg>
  `
})
export class MemoryIcon {}

@Component({
  selector: 'spinner-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="animate-spin">
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-dasharray="60"
      stroke-dashoffset="15"
      opacity="0.25" />
    <path
      d="M12 2C6.47715 2 2 6.47715 2 12"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round" />
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerIcon {}

@Component({
  selector: 'clear-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>`
})
export class ClearIcon {}

@Component({
  selector: 'expand-icon',
  imports: [],
  template: `<svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 3H21V9M9 21H3V15M21 3L14 10M3 21L10 14"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpandIcon {}
